import { MenuItem } from './types'

const setFromDate = (): any => {
  const date = new Date()
  const withinDays = window.hm.options.turnTo ? window.hm.options.turnTo.dateFrom : 56
  date.setDate(date.getDate() - withinDays)
  return date.toISOString()
}

export const normalizeReviewItemsNumber = (res): any => {
  return res.purchasedProducts.filter((product) => product.orderDate > setFromDate()).length
}

export const normalizeNewUserMenus = (userMenuKeys, userMenus): MenuItem[] => {
  const menuKeys = userMenuKeys.split(';')
  const filteredMenuItems = menuKeys.reduce((menu, key) => {
    const menuItem = userMenus.find((item) => item.key === key.trim())
    return menuItem ? [...menu, menuItem] : menu
  }, [])
  return filteredMenuItems
}

export const normalizeUserMenuWithSubtext = (
  userMenuKeys,
  userMenus,
  isAbTestEnabled,
): MenuItem[] => {
  const menuKeys = userMenuKeys.split(';')
  const filteredMenuItems = menuKeys?.reduce((finalMenu, menukey) => {
    const keys = menukey.split(':')
    const menuItem = userMenus.find((item) =>
      !isAbTestEnabled ? item.key === keys[0].trim() : item.newKey === keys[0].trim(),
    )
    if (menuItem && isAbTestEnabled) {
      menuItem.shouldShowSubtext = menukey.includes('subtext')
      menuItem.shouldShowNewTag = menukey.includes('new')
    }
    return menuItem ? [...finalMenu, menuItem] : finalMenu
  }, [])
  return filteredMenuItems
}
